import React from 'react';
import { TextField, TextFieldProps, useTheme } from '@mui/material';

interface EliceTextareaProps extends Omit<TextFieldProps, 'variant'> {
  variant?: 'default' | 'textarea';
  maxLength?: number;
}

const EliceTextarea = ({
  variant = 'default',
  rows = 5,
  placeholder = 'Placeholder...',
  multiline = true,
  maxLength,
  value,
  onChange,
  disabled,
  ...rest
}: EliceTextareaProps) => {
  const theme = useTheme();

  if (variant === 'textarea') {
    return (
      <TextField
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        multiline={multiline}
        rows={rows}
        inputProps={{ maxLength }}
        sx={{
          width: '100%',
          '& .MuiOutlinedInput-root': {
            backgroundColor: theme.palette.background.paper,
            width: '100%',
            borderRadius: '8px',
            '& fieldset': {
              borderColor: theme.palette.divider,
            },
            '&:hover fieldset': {
              borderColor: `${theme.palette.primary.main}80`, // primary에 opacity 50%
            },
            '&.Mui-focused fieldset': {
              borderColor: theme.palette.primary.main,
            },
          },
          '& .MuiInputBase-input': {
            fontSize: theme.typography.subtitle1?.fontSize || '1.3rem',
            fontWeight: theme.typography.subtitle1?.fontWeight || 500,
            lineHeight: theme.typography.subtitle1?.lineHeight || 1.48,
            color: theme.palette.text.primary,
          },
          '& .MuiInputBase-input::placeholder': {
            color: theme.palette.text.secondary,
            fontSize: theme.typography.subtitle1?.fontSize || '1.3rem',
          },
        }}
        {...rest}
      />
    );
  }

  // default variant - 기존 스타일 유지
  return (
    <TextField
      value={value}
      onChange={onChange}
      multiline
      rows={rows}
      placeholder={placeholder}
      disabled={disabled}
      sx={{
        width: '100%',
        '& .MuiOutlinedInput-root': {
          backgroundColor: theme.palette.background.paper,
          borderRadius: '1.5rem',
          padding: '1.375rem 1.5rem',
          '& fieldset': {
            borderColor: theme.palette.divider,
          },
          '&:hover fieldset': {
            borderColor: `${theme.palette.primary.main}80`, // primary에 opacity 50%
          },
          '&.Mui-focused fieldset': {
            borderColor: theme.palette.primary.main,
          },
        },
        '& .MuiInputBase-input': {
          fontSize: theme.typography.subtitle1?.fontSize || '1.375rem',
          fontWeight: theme.typography.subtitle1?.fontWeight || 700,
          lineHeight: theme.typography.subtitle1?.lineHeight || 1.925,
          color: theme.palette.text.primary,
          '&::placeholder': {
            color: theme.palette.text.secondary,
          },
        },
      }}
      {...rest}
    />
  );
};

export default EliceTextarea;
